module.exports = __webpack_public_path__ + "img/sau.c36d1991.svg";